<template>
  <nav v-if="!hideForTball">
    <v-navigation-drawer v-model="sidebar" app temporary>
      <v-list>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      class="mx-auto cv-nav"
      elevation="0"
      absolute
      dark
      color="transparent"
    >
      <v-app-bar-nav-icon
        @click="updateSideMenuItems(true)"
        class="hidden-sm-and-up"
      >
      </v-app-bar-nav-icon>
      <v-app-bar-title>
        <router-link
          to="/"
          tag="span"
          style="cursor: pointer; display: flex; align-items: center; gap: 8px"
        >
          <img
            style="height: 35px"
            src="../../public/logo_bright.png"
            alt="FaangIT.com logo"
          />
          <!-- <h1 class="white--color ml-1 mr-1">FaangIT</h1> -->
        </router-link>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <!-- stuff for admins -->
      <v-divider
        vertical
        v-if="userLoggedIn && userIsAdmin"
        class="hidden-xs-only"
      >
      </v-divider>
      <v-btn
        style="height: 100%"
        text
        to="/panel"
        class="hidden-xs-only"
        v-if="userIsAdmin"
        color="orange"
      >
        Admin panel
      </v-btn>
      <v-divider
        vertical
        v-if="userLoggedIn && userIsAdmin"
        class="hidden-xs-only"
      ></v-divider>
      <v-divider
        vertical
        v-if="userLoggedIn && (userIsReviewer || userIsAdmin || userIsDev)"
        class="hidden-xs-only"
      ></v-divider>
      <v-btn
        style="height: 100%"
        text
        to="/evaluate"
        class="hidden-xs-only"
        v-if="userLoggedIn && (userIsAdmin || userIsDev)"
      >
        Manual review
      </v-btn>
      <v-btn
        style="height: 100%"
        text
        to="/queue"
        class="hidden-xs-only"
        v-if="userLoggedIn && (userIsReviewer || userIsAdmin || userIsDev)"
      >
        Queue
      </v-btn>
      <v-btn
        style="height: 100%"
        text
        to="/propanel"
        class="hidden-xs-only"
        color="orange"
        v-if="userIsPro"
      >
        Pro Panel
      </v-btn>
      <v-divider vertical class="hidden-xs-only" v-if="userIsPro"></v-divider>
      <v-btn
        style="height: 100%"
        text
        to="/myreviews-ai"
        class="hidden-xs-only"
        v-if="userLoggedIn"
      >
        My reviews
      </v-btn>
      <v-divider vertical class="hidden-xs-only"></v-divider>
      <v-btn style="height: 100%" text to="/evaluate-ai" class="hidden-xs-only">
        Check your resume
      </v-btn>
      <!-- <v-divider vertical v-if="!userIsReviewer" class="hidden-xs-only">
      </v-divider> -->
      <!-- <v-btn
        style="height: 100%"
        text
        to="/reviewer-enrollment/info"
        class="hidden-xs-only yellow--text"
        v-if="!userIsReviewer"
      >
        Become a reviewer
      </v-btn> -->
      <v-divider
        vertical
        v-if="userLoggedIn && (userIsReviewer || userIsAdmin || userIsDev)"
        class="hidden-xs-only"
      >
      </v-divider>
      <v-btn
        style="height: 100%"
        color="orange"
        text
        to="/review"
        class="hidden-xs-only"
        v-if="userLoggedIn && (userIsReviewer || userIsAdmin || userIsDev)"
      >
        Review
      </v-btn>
      <v-divider vertical v-if="!userLoggedIn" class="hidden-xs-only">
      </v-divider>
      <v-btn
        style="height: 100%"
        text
        to="/login"
        class="hidden-xs-only"
        v-if="!userLoggedIn"
      >
        Sign in
      </v-btn>
      <LoginIcon v-if="userLoggedIn"></LoginIcon>
    </v-app-bar>
  </nav>
</template>

<script>
import LoginIcon from "../components/LoginIcon.vue";

export default {
  data() {
    return {
      hideForTball: false,
      bg: "transparent",
      appTitle: "Awesome App",
      sidebar: false,
      menuItems: [],
      loggedInMenuItems: [
        { title: "Home", path: "/", icon: "mdi-home" },
        {
          title: "Evaluate your resume",
          path: "/evaluate-ai",
          icon: "mdi-receipt-text-check-outline",
        },
        {
          title: "My reviews",
          path: "/myreviews-ai",
          icon: "mdi-format-list-bulleted",
        },
        {
          title: "Settings",
          path: "/settings",
          icon: "mdi-cog",
        },
      ],
      adminMenuItems: [
        { title: "Home", path: "/", icon: "mdi-home" },
        {
          title: "Check resume",
          path: "/evaluate-ai",
          icon: "mdi-receipt-text-check-outline",
        },
        {
          title: "Manual review",
          path: "/evaluate",
          icon: "mdi-account-check-outline",
        },
        {
          title: "Queue",
          path: "/queue",
          icon: "mdi-tray-full",
        },
        {
          title: "My reviews",
          path: "/myreviews-ai",
          icon: "mdi-format-list-bulleted",
        },
        {
          title: "Review",
          path: "/review",
          icon: "mdi-file-find",
        },
        {
          title: "Admin panel",
          path: "/panel",
          icon: "mdi-security",
        },
        {
          title: "Settings",
          path: "/settings",
          icon: "mdi-cog",
        },
      ],
      notLoggedInMenuItems: [
        { title: "Register", path: "/register", icon: "mdi-account-plus" },
        { title: "Log in", path: "/login", icon: "mdi-login" },
      ],
      userLoggedIn: false,
      userIsAdmin: false,
      userIsDev: false,
      userIsReviewer: false,
      userIsPro: false,
      maintenanceMode: false,
    };
  },
  mounted() {
    // check if path is /tball and hide navbar if so
    if (this.$route.path === "/tball") {
      this.hideForTball = true;
    }
    this.userLoggedIn = this.$store.getters.userLoggedIn;
    this.userIsAdmin = this.$store.getters.isAdmin;
    this.userIsDev = this.$store.getters.isDev;
    this.userIsReviewer = this.$store.getters.isReviewer;
    this.userIsPro = this.$store.getters.isProUser;
    this.updateSideMenuItems(false);
  },
  methods: {
    changeColor() {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        this.bg = "#2E409E"; //#2E409E #053B7D
        console.log(document.body.scrollTop);
        console.log(document.documentElement.scrollTop);
      } else {
        this.bg = "transparent";
      }
    },
    updateSideMenuItems(open) {
      // clear this.menuItems array
      this.menuItems = [];
      if (!this.$store.getters.userLoggedIn) {
        this.menuItems = this.notLoggedInMenuItems;
      } else {
        if (this.$store.getters.isAdmin || this.$store.getters.isDev) {
          this.menuItems = this.adminMenuItems;
        } else {
          this.menuItems = this.loggedInMenuItems;
          if (
            this.userIsPro &&
            !this.menuItems.find((i) => i.title === "Pro panel")
          ) {
            this.menuItems.push({
              title: "Pro panel",
              path: "/propanel",
              icon: "mdi-star-outline",
            });
          }
        }
      }
      if (open) {
        this.sidebar = !this.sidebar;
      }
    },
  },
  components: {
    LoginIcon,
  },
};
</script>

<style scoped>
.cv-nav {
  max-width: 1200px;
}
</style>
